import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {ResponseDataType} from "@/form/form.types";
import {IStoreReady} from "@/store/lib/storeSupport";
import { DocumentRequestType, IDocuments } from '@/entity/documents/documents.types';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { prepareFormData } from '@/store/utils/formDataHelper';

@Module({
    namespaced: true,
    name: 'documents',
    store,
    dynamic: true,
})
class DocumentModule extends VuexModule implements IStoreReady {
    items: IDocuments | null = null
    ready = false
    itemsLoaded = false
    itemLoaded = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ items: IDocuments; itemsLoaded: boolean }> {
        let itemsLoaded = false;
        const items = await store.$repository.documents.fetchAll(prepareFormData(data))

        if (items) {
            itemsLoaded = true;
        }
        return { items, itemsLoaded };
    }

    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        return await store.$repository.documents.delete({id: id});
    }
    @Action({rawError: true})
    async save(data: any): Promise<ResponseDataType> {
        return await store.$repository.documents.save(data);
    }

    @Mutation
    async setReady(st:boolean){
        this.ready = st
    }
}

export const DocumentsStore = getModule(DocumentModule);
